import { useEffect, useState } from 'react';

import RuntimeConfigService from '../../../../services/rt-config/RuntimeConfigService';

const useUserGuideUrl = (): string | null => {
  const [userGuideUrl, setUserGuideUrl] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    const rtConfigService = new RuntimeConfigService();

    const loadUserGuideUrl = async () => {
      try {
        const config = await rtConfigService.getRuntimeApiConfig();
        const url = config.userGuideUrl?.trim();
        if (isMounted) {
          setUserGuideUrl(url || null);
        }
      } catch {
        if (isMounted) {
          setUserGuideUrl(null);
        }
      }
    };

    void loadUserGuideUrl();

    return () => {
      isMounted = false;
    };
  }, []);

  return userGuideUrl;
};

export default useUserGuideUrl;
